<div>
	<div>
		<sbu-icon-button [configuration]="backBtnConfig"></sbu-icon-button>
	</div>
	<div id="logo-container" (click)="onLogoClick($event)">
		<sbu-image id="logo" [configuration]="logoImgConfig"></sbu-image>
	</div>
	<div>
		@if (isAuthenticated()) {
			<sbu-menu [configuration]="menuConfig"></sbu-menu>
		}
	</div>
</div>